/**
 * Vedanskrix — Domain Configuration
 *
 * All 6 subdomains of vedanskrix.com.
 * Update these if any domain changes in the future.
 */

export const domains = {
  main:        'https://vedanskrix.com',
  itTraining:  'https://training.vedanskrix.com',
  technology:  'https://technology.vedanskrix.com',
  admission:   'https://eduadmit.vedanskrix.com',
  career:      'https://careerdevelopment.vedanskrix.com',
  global:      'https://globalopportunities.vedanskrix.com',
};

export default domains;
